<section
         #sourceTable
         [id]="templateId"
         class="mat-elevation-z8 max-h-[calc(100%-45px)]"
         tabindex="0"
         (scroll)="onScroll($event, sourceTable.scrollLeft, sourceTable.scrollTop)">
    <table
           mat-table
           aria-describedby="Instance data table"
           [dataSource]="data"
           class="pAdjust mat-elevation-z2 matTableContainer"
           [trackBy]="trackRecord">
        <ng-container [matColumnDef]="columnId" *ngFor="let columnId of selectedColumns" [sticky]="columnId === 'SELECTRECORD'">
            <ng-container [ngSwitch]="columnKeyPair[columnId]?.type">
                <ng-container *ngSwitchCase="'SELECTRECORD'">
                    <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                        <ng-container *ngIf="columnKeyPair[columnId].showCheckboxInHeader">
                            <material-checkbox
                                               [model]="selectAllRecords"
                                               [badge]="selectedRecordsCount > 0 ? selectedRecordsCount : null"
                                               (modelChange)="selectAllRecords = $event; onSelectAllRecords()"
                                               [disabled]="
                                    !dataSource ||
                                    (dataSource && !dataSource.data) ||
                                    (dataSource.data && dataSource.data.length === 0) ||
                                    (isMisMatchGroup && !canSelectMultiple)
                                "></material-checkbox>
                        </ng-container>
                        <ng-container *ngIf="!columnKeyPair[columnId].showCheckboxInHeader">
                            <span [textContent]="columnKeyPair[columnId] && columnKeyPair[columnId].name"></span>
                        </ng-container>
                    </th>
                    <td mat-cell *matCellDef="let element" class="matTableCell">
                        <material-checkbox
                                           [hidden]="
                                (templateId === 'source1' && element.hideSource1Checkbox) ||
                                (templateId === 'source2' && element.hideSource2Checkbox)
                            "
                                           [model]="element.selected"
                                           [disabled]="
                                isMisMatchGroup && !canSelectMultiple ? (selectedRecordsCount > 0 ? !element.selected : false) : false
                            "
                                           (modelChange)="element.selected = $event; onRecordSelectionChange(element)"
                                           class="recordSelectCheckboxContainer"></material-checkbox>
                    </td>
                </ng-container>
                <ng-container *ngSwitchCase="'text'">
                    <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader" [title]="columnKeyPair[columnId]?.name">
                        <span [textContent]="columnKeyPair[columnId]?.name | pascalToCamel"></span>
                        <div *ngIf="columnSearchRequired && columnKeyPair[columnId]?.searchable" class="columnSearch d-flex items-center">
                            <mat-form-field [floatLabel]="'auto'">
                                <div class="flex">
                                    <input
                                           matInput
                                           autocomplete="off"
                                           [formControl]="searchColumnControl"
                                           floatLabel="never"
                                           debounce="1000"
                                           (eventHandler)="searchInputModelChange(columnId)"
                                           placeholder="Search" />
                                    <material-button
                                                     buttonType="icon"
                                                     [size]="'small'"
                                                     [titleText]="'Search'"
                                                     suffixIcon="search"
                                                     suffixIconType="material"
                                                     [hideRipple]="true"
                                                     [classList]="['actionButtons']"></material-button>
                                </div>
                            </mat-form-field>
                            <div class="ml-[6px]">
                                <ng-container
                                              class="ml-[6px]"
                                              *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="matTableCell" [title]="element[columnId] || '--'">
                        <span
                              [class.dataTypeTextAlign]="
                                ['INT', 'LONG', 'FLOAT', 'DOUBLE', 'DECIMAL'].includes(columnKeyPair[columnId]?.inputType)
                            "
                              [textContent]="element[columnId]"></span>
                    </td>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <ng-container [ngSwitch]="columnTypePair[columnId]">
                        <ng-container *ngSwitchCase="'ALL_COLUMNS_LIST'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader logMenuIcon">
                                <span class="material-icons logIcon" [matMenuTriggerFor]="logMenu">menu</span>
                                <mat-menu #logMenu="matMenu" [class]="'tableLogMenu !bg-white'" xPosition="after" yPosition="below">
                                    <div class="logMenu">
                                        <div class="logFilter" stop-propagation>
                                            <mat-form-field>
                                                <div class="flex">
                                                    <input
                                                           matInput
                                                           class="filterInput"
                                                           autocomplete="off"
                                                           placeholder="Filter Table Columns"
                                                           [(ngModel)]="searchColumns" />
                                                    <material-button
                                                                     buttonType="icon"
                                                                     [titleText]="'Clear'"
                                                                     size="small"
                                                                     [hideRipple]="true"
                                                                     suffixIcon="close"
                                                                     suffixIconType="material"
                                                                     (buttonClicked)="searchColumns = ''"></material-button>
                                                </div>
                                            </mat-form-field>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex justify-content-around align-items-center checkStyle" stop-propagation>
                                                <material-checkbox
                                                                   [(model)]="selectAll"
                                                                   (modelChange)="selectAllFilters($event)"
                                                                   [name]="'Select All'"
                                                                   [title]="'Select All'"
                                                                   [showName]="true"
                                                                   id="selectAllLabel"
                                                                   [disabled]="false"></material-checkbox>
                                            </div>
                                            <div class="d-flex align-items-center gap-2">
                                                <span
                                                      *ngIf="useUserPreferences"
                                                      class="material-symbols-outlined cursor-pointer"
                                                      (click)="onResetPreferences.emit()"
                                                      title="Reset to default columns">
                                                    reset_wrench
                                                </span>
                                                <material-button
                                                                 [color]="'primary'"
                                                                 [disabled]="clonedColumns.length === 0"
                                                                 [text]="'Apply'"
                                                                 (buttonClicked)="cloneSubmit()"></material-button>
                                            </div>
                                        </div>
                                        <div
                                             class="logListItems"
                                             cdkDropList
                                             stop-propagation
                                             [cdkDropListData]="visibleColumns"
                                             (cdkDropListDropped)="onColumnDrop($event)">
                                            <div
                                                 *ngFor="let column of visibleColumns; let i = index; trackBy: trackByAllColumnsMethod"
                                                 stop-propagation
                                                 class="d-flex align-items-center tempList"
                                                 cdkDrag>
                                                <div class="drag-handle cursor-move mr-2">
                                                    <mat-icon>drag_indicator</mat-icon>
                                                </div>
                                                <div class="actionCheckBox mCheckbox">
                                                    <material-checkbox
                                                                       [hidden]="column.type === 'SELECTRECORD' || column.name === 'dynamicActions'"
                                                                       [model]="clonedColumns.indexOf(column.id) > -1"
                                                                       (modelChange)="checkboxSelect($event, column)"
                                                                       [name]="column.name"
                                                                       [showName]="true"></material-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-menu>
                                <ng-container *ngIf="columnSearchRequired">
                                    <div class="searchHiddenDiv"></div>
                                </ng-container>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell"></td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'ACTIONS'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader alignCenter">
                                <div>Actions</div>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell alignCenter">
                                <div class="actionsMenu tableActionsMenu">
                                    <ng-container *ngFor="let action of recordActions; trackBy: trackByActionsMethod">
                                        <span [hidden]="!actionVisibility[element.recordId][action.displayName]">
                                            <ng-container
                                                          *ngIf="
                                                    !action.conditionalDisplay ||
                                                    (action.byFieldValue &&
                                                        ((action.conditionType === 'NOT_EQUALS' &&
                                                            element[action.conditionalFieldId] !== action.conditionalFieldValue &&
                                                            !(
                                                                action.isArray &&
                                                                action.conditionalFieldValue.indexOf(element[action.conditionalFieldId]) >
                                                                    -1
                                                            )) ||
                                                            (action.conditionType === 'EQUALS' &&
                                                                element[action.conditionalFieldId] === action.conditionalFieldValue)))
                                                ">
                                                <material-button
                                                                 buttonType="icon"
                                                                 [titleText]="action.displayName"
                                                                 (buttonClicked)="action.onActionTrigger?.(element, action)"
                                                                 [suffixIcon]="action.iconName"
                                                                 suffixIconType="material"
                                                                 [classList]="[
                                                        'actionButtons',
                                                        action.iconName === 'warning' ? 'displayActionColor' : ''
                                                    ]"></material-button>
                                            </ng-container>
                                        </span>
                                    </ng-container>
                                </div>
                                <ng-container *ngIf="!recordActions || recordActions.length === 0">
                                    <div>
                                        <material-button buttonType="flat" [text]="'No Actions Found'" [disabled]="true"></material-button>
                                    </div>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="columnKeyPair[columnId]?.name"></span>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <span
                                      [class.dataTypeTextAlign]="
                                        ['INT', 'LONG', 'FLOAT', 'DOUBLE', 'DECIMAL'].includes(columnKeyPair[columnId]?.inputType)
                                    "
                                      [textContent]="element[columnId]"></span>
                            </td>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <td class="expandedTableRow" mat-cell *matCellDef="let element" [attr.colspan]="selectedColumns.length">
                <div class="example-element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"></div>
            </td>
        </ng-container>
        <ng-container matColumnDef="loading">
            <td mat-footer-cell class="matTableMessages tdFull" *matFooterCellDef colspan="100%">
                <div class="loaderBlock isLoading"></div>
            </td>
        </ng-container>
        <ng-container matColumnDef="noData">
            <div>
                <td mat-footer-cell class="matTableMessages" *matFooterCellDef colspan="100%">
                    <span [textContent]="noRecordMsg || 'No records Found'"></span>
                </td>
            </div>
        </ng-container>
        <ng-container matColumnDef="noRecords">
            <div>
                <td mat-footer-cell class="matTableMessages noRecordMessage" *matFooterCellDef colspan="100%">No records found</td>
            </div>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="selectedColumns; sticky: true" [ngClass]="{ tableHeaderPadding: columnSearchRequired }"></tr>
        <tr
            mat-footer-row
            *matFooterRowDef="['loading']"
            [ngClass]="{ hide: dataSource !== null && !loading }"
            [class.loadingTable]="loading"></tr>
        <tr
            mat-footer-row
            *matFooterRowDef="['noData']"
            [ngClass]="{ hide: !(dataSource !== null && dataSource.data.length === 0 && !loading) }"></tr>
        <tr mat-footer-row *matFooterRowDef="['noRecords']" [ngClass]="{ hide: !noRecordsFound }"></tr>
        <ng-template let-element matRowDef [matRowDefColumns]="selectedColumns">
            <tr
                mat-row
                class="example-element-row"
                [ngClass]="['!bg-[' + element.bgColor + ']']"
                [class.example-expanded-row]="expandedElement === element"
                [class.disabled]="element.disabled"
                [class.matTableError]="element.errorsCount && element.errorsCount > 0"
                [class.matTableWarning]="element.warningsCount && element.warningsCount > 0"
                (click)="clickedRecord.emit(element)"></tr>
        </ng-template>
    </table>
</section>
